import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-item-manager',
  templateUrl: './item-manager.component.html',
  styleUrls: ['./item-manager.component.css']
})
export class ItemManagerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
